import type { LanguageCode } from "@/i18n/config";

// All flags share the same 4:3 viewBox and stretch to fill — guarantees
// identical rendered size across languages, on any platform.
const VB = "0 0 12 9";

const flags: Record<LanguageCode, JSX.Element> = {
  sv: (
    <svg viewBox={VB} preserveAspectRatio="none" aria-hidden>
      <rect width="12" height="9" fill="#006AA7" />
      <rect x="3.75" width="1.5" height="9" fill="#FECC00" />
      <rect y="3.75" width="12" height="1.5" fill="#FECC00" />
    </svg>
  ),
  no: (
    <svg viewBox={VB} preserveAspectRatio="none" aria-hidden>
      <rect width="12" height="9" fill="#EF2B2D" />
      <rect x="3" width="2" height="9" fill="#fff" />
      <rect y="3.5" width="12" height="2" fill="#fff" />
      <rect x="3.5" width="1" height="9" fill="#002868" />
      <rect y="4" width="12" height="1" fill="#002868" />
    </svg>
  ),
  fi: (
    <svg viewBox={VB} preserveAspectRatio="none" aria-hidden>
      <rect width="12" height="9" fill="#fff" />
      <rect x="3.5" width="1.8" height="9" fill="#003580" />
      <rect y="3.6" width="12" height="1.8" fill="#003580" />
    </svg>
  ),
  is: (
    <svg viewBox={VB} preserveAspectRatio="none" aria-hidden>
      <rect width="12" height="9" fill="#02529C" />
      <rect x="3.2" width="2.2" height="9" fill="#fff" />
      <rect y="3.4" width="12" height="2.2" fill="#fff" />
      <rect x="3.7" width="1.2" height="9" fill="#DC1E35" />
      <rect y="3.9" width="12" height="1.2" fill="#DC1E35" />
    </svg>
  ),
  da: (
    <svg viewBox={VB} preserveAspectRatio="none" aria-hidden>
      <rect width="12" height="9" fill="#C8102E" />
      <rect x="3.5" width="1.5" height="9" fill="#fff" />
      <rect y="3.75" width="12" height="1.5" fill="#fff" />
    </svg>
  ),
  en: (
    <svg viewBox={VB} preserveAspectRatio="none" aria-hidden>
      <clipPath id="fg-uk-c"><path d="M0,0 v9 h12 v-9 z" /></clipPath>
      <rect width="12" height="9" fill="#012169" />
      <g clipPath="url(#fg-uk-c)">
        <path d="M0,0 L12,9 M12,0 L0,9" stroke="#fff" strokeWidth="1.6" />
        <path d="M0,0 L12,9 M12,0 L0,9" stroke="#C8102E" strokeWidth="1" />
        <path d="M6,0 v9 M0,4.5 h12" stroke="#fff" strokeWidth="2.2" />
        <path d="M6,0 v9 M0,4.5 h12" stroke="#C8102E" strokeWidth="1.3" />
      </g>
    </svg>
  ),
};

export const FlagIcon = ({
  code,
  className = "h-3.5 w-[18px] rounded-[2px] overflow-hidden shadow-[0_0_0_1px_hsl(var(--border))]",
}: {
  code: LanguageCode;
  className?: string;
}) => (
  <span className={`inline-flex shrink-0 ${className}`}>
    <span className="block w-full h-full [&>svg]:w-full [&>svg]:h-full [&>svg]:block">
      {flags[code]}
    </span>
  </span>
);
